module.exports = __webpack_public_path__ + "img/ministerioproteccion-removebg-preview.de44bf45.png";